import { LogIn } from "lucide-react";
import { observer } from "mobx-react-lite";
import type { FC } from "react";

import { CustomButton } from "@/components/atoms";
import { DeactivateSwitch } from "@/components/units";
import type {
  ActionStateType,
  ConfirmType,
} from "@/components/units/ActionDialog/type";
import { ImpersonationType } from "@/store/ImpersonationStore";
import { rootStore } from "@/store/RootStore";
import { commonIconProps20 } from "@/utils/constants";

interface AdminPageActionsProps {
  name: string;
  state: ActionStateType;
  onConfirm: ConfirmType;
  active?: boolean;
  disabled?: boolean;
}

const AdminPageActions: FC<AdminPageActionsProps> = observer(
  ({ state, name, onConfirm, active = true, disabled = false }) => {
    const impersonation = rootStore.impersonation;

    const getImpersonationType = (state: ActionStateType) => {
      switch (state) {
        case "brand":
          return ImpersonationType.Brand;
        case "user":
          return ImpersonationType.User;
        case "branch":
          return ImpersonationType.Branch;
        case "group":
          return ImpersonationType.Group;
        default:
          return null;
      }
    };

    const impersonationType = getImpersonationType(state);

    return (
      <div className="flex items-center gap-4 self-end md:self-auto w-full md:w-fit justify-between md:justify-normal mt-3 md:mt-0">
        <DeactivateSwitch
          state={state}
          name={name}
          onConfirm={onConfirm}
          active={active}
          disabled={disabled}
        />
        {!impersonation.isImpersonating && impersonationType && (
          <CustomButton
            className="gap-[11px] px-[15px]!"
            data-testid="admin-brand-login-button"
            onClick={() => impersonation.logAs(impersonationType!, name)}
          >
            <LogIn {...commonIconProps20} />
            <span>Log as {state}</span>
          </CustomButton>
        )}
      </div>
    );
  }
);

export default AdminPageActions;
